import PropTypes from 'prop-types';
import React from 'react';

import { SecondaryHeading } from 'components/Headings';
import Image from 'components/ImageV2';
import { IMAGE_RATIOS, IMAGE_WIDTHS } from 'constants/images';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const PETER_CLIPBOARD_SRC =
  'https://cdn.allbirds.com/image/fetch/v1606303608/https://cdn.shopify.com/s/files/1/0074/1307/1990/t/782/assets/illustration_peter-clipboard.png';
const PETER_CLIPBOARD_ALT = 'Peter holding a clipboard.';

const Confirmation = ({ styles }) => (
  <div className="Confirmation" style={styles}>
    <div className="Confirmation__heading">
      <SecondaryHeading>{I18n.localize('pdp.updateForm.youreAllSet')}</SecondaryHeading>
    </div>
    <div className="Confirmation__illustration">
      <Image
        src={PETER_CLIPBOARD_SRC}
        alt={PETER_CLIPBOARD_ALT}
        width={IMAGE_WIDTHS.W_200}
        ratio={IMAGE_RATIOS.R_1x1}
      />
    </div>

    <style jsx>
      {`
        .Confirmation {
          display: flex;
          width: 100%;
          flex-direction: column;
          align-items: center;
          height: 100%;
        }

        .Confirmation__heading {
          margin-bottom: ${Theme.get('spacing') * 3}px;
        }

        @media ${largeUp} {
          .Confirmation__heading {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .Confirmation__illustration {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
      `}
    </style>
  </div>
);

Confirmation.propTypes = {
  styles: PropTypes.shape({}),
};

Confirmation.defaultProps = {
  styles: {},
};

export default Confirmation;
